import './base.scss';
import { Device } from '@chat/utils';
var device = new Device();
if (device.isMobile) {
    // @ts-ignore
    import('./wap.scss');
}
else {
    // @ts-ignore
    import('./pc.scss');
}
